import React from 'react';
import withClickOutsideOnOverlay from '../../../../hoc/withClickOutsideOnOverlay';
import BasicFormWithValidation from '../../../forms/BasicFormWithValidation';
import {FormWithCancelButton} from '../../../forms/FormWithCancelButton';
import { validateScriptName } from '../../../../services/validations/validateScriptName';

class NewTransformForm extends FormWithCancelButton {

    validateTransformName = ({ transformName }) => {
        const { project } = this.props;

        return validateScriptName(transformName, project, 'Transform');
    }

    ok = ({ transformName }) => {
        const { addNewTransform, onClose } = this.props;
        onClose();
        addNewTransform({ transformName });
    }

    render() {
        return <BasicFormWithValidation
            title="Create New Transform"
            type="add"
            hasCloseIcon={true}
            inputs={[{
                name: 'transformName',
                label: 'Transform name',
                autoFocus: true,
                maxLength: 50,
                maxLengthMsg: `Max transform name length: 50 characters`,
                value: '',
                rules: [this.validateTransformName],
                applyOnEnter: true
            }]}
            okButton={{
                label: 'Create',
                action: this.ok
            }}
            cancelButton={{
                label: 'Cancel',
                action: this.cancel,
            }}
        />;
    }
}

export default withClickOutsideOnOverlay(NewTransformForm);